import { createContext, useContext, useEffect, useState } from "react";

const dict = {
  pt: {
    nav: { tours: "Tours", yachts: "Iates", fleet: "Frota", about: "A Casa", contact: "Contactos", book: "Reservar" },
    hero: {
      over: "Turismo privado de alta gama — Lisboa",
      lines: ["Portugal,", "ao ritmo", "do luxo."],
      sub: "Tours privados em viaturas de alta gama por todo o país e passeios de iate pelo Rio Tejo. Um único anfitrião, do primeiro contacto ao último brinde.",
      cta: "Reservar experiência",
      cta2: "Ver tours",
      scroll: "Deslize",
      badge: "Partidas diárias de Lisboa",
    },
    tours: {
      over: "01 — Por estrada",
      title: ["Todo o país,", "em primeira classe."],
      sub: "Escolha o destino. Nós tratamos do resto — viatura de alta gama, motorista privado e um roteiro desenhado à sua medida.",
      book: "Reservar",
      request: "Preço sob consulta",
      from: "Desde",
    },
    yachts: {
      over: "02 — Pelo rio",
      title: ["O Tejo,", "visto do convés."],
      sub: "Passeios privados de barco e iate pelo Rio Tejo e arredores — de Belém ao Atlântico, à hora dourada.",
      book: "Reservar a bordo",
    },
    manifesto: {
      over: "A Casa",
      text: "Não organizamos excursões. Abrimos as portas de Portugal a quem viaja com exigência — em silêncio, com tempo e com o conforto de uma viatura de alta gama à espera, sempre.",
      pillars: [
        ["Só alta gama", "Viaturas e embarcações premium, impecáveis em cada viagem."],
        ["Todo o país", "De Sintra ao Douro, de Fátima a Évora — partindo de Lisboa."],
        ["Totalmente privado", "Sem grupos, sem pressa. O dia é seu."],
        ["Roteiro à medida", "Ajustamos paragens, horários e ritmo ao seu gosto."],
      ],
    },
    fleet: { over: "03 — A Frota", title: ["Escolha a", "sua cabine."], note: "Modelos exatos da frota a confirmar no pedido de reserva." },
    booking: {
      over: "04 — Reservar",
      title: ["O seu pedido,", "a nossa atenção."],
      sub: "Envie o pedido e confirmamos disponibilidade e preço. Se preferir, garanta já a data com o pagamento do sinal.",
      experience: "Experiência", date: "Data", time: "Hora preferida", guests: "Passageiros",
      name: "Nome completo", email: "Email", phone: "Telefone / WhatsApp", message: "Pedidos especiais (opcional)",
      groupTours: "Tours em viatura de alta gama", groupYachts: "Passeios de barco / iate",
      deposit: "Garantir a data agora com sinal de",
      depositNote: "Pagamento seguro por Stripe. Valor descontado no total.",
      submit: "Enviar pedido", submitPay: "Enviar e pagar sinal", sending: "A enviar…",
      ok: "Pedido recebido. Entraremos em contacto muito em breve.",
      okTitle: "Obrigado.", again: "Fazer novo pedido", err: "Não foi possível enviar. Verifique os dados e tente novamente.",
      custom: "Tour à medida (outro destino)",
    },
    contact: {
      over: "Contactos", title: "Falemos.", whatsapp: "WhatsApp", call: "Ligar", email: "Email", base: "Base",
      hours: "Atendimento todos os dias",
    },
    footer: { rights: "Todos os direitos reservados.", admin: "Área reservada" },
    pay: {
      checking: "A confirmar pagamento…", ok: "Sinal pago. A sua data está garantida.",
      okSub: "Receberá a confirmação por email. Obrigado por escolher a Turismo da Capital.",
      fail: "Não conseguimos confirmar o pagamento.", cancel: "Pagamento cancelado.",
      cancelSub: "O seu pedido foi registado. Pode pagar o sinal mais tarde, quando o contactarmos.", home: "Voltar ao início",
    },
    duration: { full: "Dia inteiro", half: "Meio dia", sunset: "Fim de tarde", flex: "Duração à medida" },
  },
  en: {
    nav: { tours: "Tours", yachts: "Yachts", fleet: "Fleet", about: "The House", contact: "Contact", book: "Book" },
    hero: {
      over: "Private luxury touring — Lisbon",
      lines: ["Portugal,", "at the pace", "of luxury."],
      sub: "Private tours in high-end vehicles across the whole country and yacht cruises on the Tagus river. One host, from first hello to the final toast.",
      cta: "Book an experience",
      cta2: "See tours",
      scroll: "Scroll",
      badge: "Daily departures from Lisbon",
    },
    tours: {
      over: "01 — By road",
      title: ["The whole country,", "first class."],
      sub: "Choose your destination. We handle the rest — a high-end vehicle, a private chauffeur and an itinerary shaped around you.",
      book: "Book",
      request: "Price on request",
      from: "From",
    },
    yachts: {
      over: "02 — By river",
      title: ["The Tagus,", "from the deck."],
      sub: "Private boat and yacht cruises on the Tagus river and surroundings — from Belém to the Atlantic, at golden hour.",
      book: "Book on board",
    },
    manifesto: {
      over: "The House",
      text: "We don't run excursions. We open Portugal's doors to discerning travellers — quietly, unhurried, with a high-end vehicle always waiting for you.",
      pillars: [
        ["High-end only", "Premium vehicles and boats, immaculate on every trip."],
        ["The whole country", "From Sintra to the Douro, Fátima to Évora — leaving from Lisbon."],
        ["Fully private", "No groups, no rush. The day is yours."],
        ["Tailored routes", "Stops, timings and pace adjusted to you."],
      ],
    },
    fleet: { over: "03 — The Fleet", title: ["Choose", "your cabin."], note: "Exact fleet models confirmed with your booking request." },
    booking: {
      over: "04 — Book",
      title: ["Your request,", "our full attention."],
      sub: "Send your request and we'll confirm availability and price. Or secure your date right away with a deposit.",
      experience: "Experience", date: "Date", time: "Preferred time", guests: "Passengers",
      name: "Full name", email: "Email", phone: "Phone / WhatsApp", message: "Special requests (optional)",
      groupTours: "High-end vehicle tours", groupYachts: "Boat / yacht cruises",
      deposit: "Secure the date now with a deposit of",
      depositNote: "Secure payment by Stripe. Deducted from the total.",
      submit: "Send request", submitPay: "Send & pay deposit", sending: "Sending…",
      ok: "Request received. We'll be in touch very soon.",
      okTitle: "Thank you.", again: "Make another request", err: "Couldn't send. Please check your details and try again.",
      custom: "Tailor-made tour (other destination)",
    },
    contact: {
      over: "Contact", title: "Let's talk.", whatsapp: "WhatsApp", call: "Call", email: "Email", base: "Base",
      hours: "Available every day",
    },
    footer: { rights: "All rights reserved.", admin: "Staff area" },
    pay: {
      checking: "Confirming payment…", ok: "Deposit paid. Your date is secured.",
      okSub: "You'll receive confirmation by email. Thank you for choosing Turismo da Capital.",
      fail: "We couldn't confirm the payment.", cancel: "Payment cancelled.",
      cancelSub: "Your request was saved. You can pay the deposit later when we contact you.", home: "Back to home",
    },
    duration: { full: "Full day", half: "Half day", sunset: "Late afternoon", flex: "Flexible duration" },
  },
};

const LangCtx = createContext({ lang: "pt", t: dict.pt, setLang: () => {} });

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("tdc_lang") || "pt");
  useEffect(() => {
    localStorage.setItem("tdc_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  return <LangCtx.Provider value={{ lang, setLang, t: dict[lang] }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
